<template>
  <div class="parameter-group">

    <h5 class="group-title">
      {{ groupTitle }}
    </h5>

    <div class="rules-header">
      <p>Regra do Intervalo</p>
      <p>Valor da Regra</p>
    </div>

    <template v-if="parameter === 'internal_history'">

      <div class="rule-row">
        <span>Índice de Pontualidade seja menor que</span>

        <div class="value-wrapper">
          <b-form-input
            :value="toPercent(values.on_time)"
            type="number"
            @input="updatePercent('on_time', $event)"
          />
          <span>%</span>
        </div>
      </div>

      <div class="rule-row">
        <span>Atraso acima de 15 dias seja maior que</span>

        <div class="value-wrapper">
          <b-form-input
            :value="toPercent(values.delay)"
            type="number"
            @input="updatePercent('delay', $event)"
          />
          <span>%</span>
        </div>
      </div>

      <div class="rule-row">
        <span>Valor de Recompra seja maior que</span>

        <div class="value-wrapper">
          <b-form-input
            :value="toPercent(values.rebuy)"
            type="number"
            @input="updatePercent('rebuy', $event)"
          />
          <span>%</span>
        </div>
      </div>

    </template>

    <template v-else-if="parameter === 'beecred'">

      <div class="rule-row keyword-rule">
        <span>
          Se a empresa conter anotações com as palavras chaves:
        </span>

        <div class="keyword-wrapper">
          <div class="keywords">
            <span
              v-for="(word, index) in values.words"
              :key="index"
              class="keyword"
            >
              {{ word }}

              <button
                type="button"
                @click="removeKeyword(index)"
              >
                ×
              </button>
            </span>
          </div>

          <b-button
            size="sm"
            variant="primary"
            @click="addKeyword"
          >
            Incluir palavra-chave
          </b-button>
        </div>
      </div>

    </template>

    <template v-else-if="parameter === 'process'">

      <div class="rule-row">
        <span>Processos Ativos representam mais de</span>

        <div class="value-wrapper">
          <b-form-input
            :value="toPercent(values.total)"
            type="number"
            @input="updatePercent('total', $event)"
          />
          <span>%</span>
        </div>
      </div>

      <div class="rule-row">
        <span>
          Processos Ativos com menos de 1 ano representam mais de
        </span>

        <div class="value-wrapper">
          <b-form-input
            :value="toPercent(values.last_year)"
            type="number"
            @input="updatePercent('last_year', $event)"
          />
          <span>%</span>
        </div>
      </div>

    </template>

    <template v-else-if="parameter === 'pgfn' || parameter === 'pge'">

      <div class="rule-row">
        <span>
          {{ groupTitle }} representa mais de
        </span>

        <div class="value-wrapper">
          <b-form-input
            :value="toPercent(values.total)"
            type="number"
            @input="updatePercent('total', $event)"
          />
          <span>%</span>
        </div>
      </div>

      <div class="rule-row">
        <span>
          {{ groupTitle }} com menos de 1 ano representa mais de
        </span>

        <div class="value-wrapper">
          <b-form-input
            :value="toPercent(values.last_year)"
            type="number"
            @input="updatePercent('last_year', $event)"
          />
          <span>%</span>
        </div>
      </div>

    </template>

    <template v-else-if="parameter === 'serasa'">

      <div class="rule-row">
        <span>Possui Liminar?</span>

        <div class="value-wrapper">
          <b-form-input
            :value="values.injunction ? 'Sim' : 'Não'"
            disabled
          />
        </div>
      </div>

      <div class="rule-row">
        <span>Total Restrições representam mais de</span>

        <div class="value-wrapper">
          <b-form-input
            :value="toPercent(values.total_restrictions)"
            type="number"
            @input="updatePercent('total_restrictions', $event)"
          />
          <span>%</span>
        </div>
      </div>

      <div class="rule-row">
        <span>
          Total Restrições com menos de 1 ano representam mais de
        </span>

        <div class="value-wrapper">
          <b-form-input
            :value="toPercent(values.restrictions_under_one_year)"
            type="number"
            @input="updatePercent('restrictions_under_one_year', $event)"
          />
          <span>%</span>
        </div>
      </div>

      <div class="rule-row">
        <span>
          Refins possuem um valor total acima de

        <span class="money-wrapper">
            R$
          <b-form-input
            :value="formatMoney(values.refinancing_amount)"
            @input="updateMoney('refinancing_amount', $event)"
          />
          </span>
          e representam
          </span>

        <div class="value-wrapper">
          <b-form-input
            :value="toPercent(values.refinancing_restrictions)"
            type="number"
            @input="updatePercent('refinancing_restrictions', $event)"
          />
          <span>%</span>
        </div>
      </div>

      <div class="rule-row">
        <span>
          Pefins possuem um valor total acima de

          <span class="money-wrapper">
            R$
            <b-form-input
              :value="formatMoney(values.pefin_amount)"
              @input="updateMoney('pefin_amount', $event)"
            />
          </span>

          e representam
        </span>

        <div class="value-wrapper">
          <b-form-input
            :value="toPercent(values.pefin_restrictions)"
            type="number"
            @input="updatePercent('pefin_restrictions', $event)"
          />
          <span>%</span>
        </div>
      </div>

      <div class="rule-row">
        <span>
          O valor médio de Protestos é maior que

          <span class="money-wrapper">
            R$
            <b-form-input
              :value="formatMoney(values.average_protest_amount)"
              @input="updateMoney('average_protest_amount', $event)"
            />
          </span>

          e representam
        </span>

        <div class="value-wrapper">
          <b-form-input
            :value="toPercent(values.protest_restrictions)"
            type="number"
            @input="updatePercent('protest_restrictions', $event)"
          />
          <span>%</span>
        </div>
      </div>

      <div class="rule-row">
        <span>
          Div. Vencida possui um valor total acima de

          <span class="money-wrapper">
            R$
            <b-form-input
              :value="formatMoney(values.overdue_divisions_amount)"
              @input="updateMoney('overdue_divisions_amount', $event)"
            />
          </span>

          e representam
        </span>

        <div class="value-wrapper">
          <b-form-input
            :value="toPercent(values.overdue_divisions)"
            type="number"
            @input="updatePercent('overdue_divisions', $event)"
          />
          <span>%</span>
        </div>
      </div>

      <div class="rule-row">
        <span>
          Ações Judiciais possui um valor total acima de

          <span class="money-wrapper">
            R$
            <b-form-input
              :value="formatMoney(values.judicial_actions_amount)"
              @input="updateMoney('judicial_actions_amount', $event)"
            />
          </span>

          e representam
        </span>

        <div class="value-wrapper">
          <b-form-input
            :value="toPercent(values.judicial_actions)"
            type="number"
            @input="updatePercent('judicial_actions', $event)"
          />
          <span>%</span>
        </div>
      </div>

    </template>

    <template v-else-if="parameter === 'scr'">

      <div class="rule-row">
        <span>Vencidos a mais de 30 dias representam mais de</span>

        <div class="value-wrapper">
          <b-form-input
            :value="toPercent(values.overdue)"
            type="number"
            @input="updatePercent('overdue', $event)"
          />
          <span>%</span>
        </div>
      </div>

      <div class="rule-row">
        <span>Prejuízo representam mais de</span>

        <div class="value-wrapper">
          <b-form-input
            :value="toPercent(values.injury)"
            type="number"
            @input="updatePercent('injury', $event)"
          />
          <span>%</span>
        </div>
      </div>

      <div class="rule-row">
        <span>
          A soma dos Vencidos a mais de 30 dias e Prejuízo representam mais de
        </span>

        <div class="value-wrapper">
          <b-form-input
            :value="toPercent(values.invoicing)"
            type="number"
            @input="updatePercent('invoicing', $event)"
          />
          <span>%</span>
        </div>
      </div>

    </template>

    <template v-else-if="parameter === 'blacklist'">

      <div class="rule-row">
        <span>Empresa possui registro na Blacklist?</span>

        <div class="value-wrapper">
          <b-form-input
            :value="values.has ? 'Sim' : 'Não'"
            disabled
          />
        </div>
      </div>

    </template>
    <b-modal
      v-model="showKeywordModal"
      title="Incluir palavra-chave"
      centered
      ok-only
      ok-title="Adicionar"
      modal-class="beecred-keyword-modal"
      @ok="confirmAddKeyword"
    >
      <b-form-group label="Palavra-chave">
        <b-form-input
          v-model="newKeyword"
          autocomplete="off"
          placeholder="Digite a palavra-chave"
          @keyup.enter="confirmAddKeyword"
        />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import {
  BFormInput,
  BFormGroup,
  BButton,
  BModal

} from 'bootstrap-vue'

export default {
  name: 'CreditProductParameterGroup',

  components: {
    BFormInput,
    BFormGroup,
    BButton,
    BModal

  },

  props: {
    parameter: {
      type: String,
      required: true
    },

    values: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      showKeywordModal: false,
       newKeyword: ''
    }
  },

  computed: {
    groupTitle() {
      const titles = {
        internal_history: 'Histórico Interno',
        beecred: 'Anotações de Mercado',
        process: 'Processos',
        pgfn: 'Dívida Ativa - PGFN',
        pge: 'Dívida Ativa - PGE',
        serasa: 'Restrições',
        scr: 'SCR',
        blacklist: 'Blacklist'
      }

      return titles[this.parameter] || this.parameter
    }
  },

  methods: {
    update(field, value) {
      this.$emit('input', {
        parameter: this.parameter,
        field,
        value
      })
    },

    updatePercent(field, value) {
      const number = Number(value)

      if (number > 100) {
        this.$toast.error('O valor da porcentagem não pode ser maior que 100%.')
        return
      }

      this.update(
        field,
        Number.isNaN(number)
          ? 0
          : number / 100
      )
    },

    toPercent(value) {
      if (value === null || value === undefined || value === '') {
        return ''
      }

       return Number((Number(value) * 100).toFixed(2))
    },

    formatMoney(value) {
      if (value === null || value === undefined || value === '') {
        return '0,00'
      }

      return Number(value).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },

    updateMoney(field, value) {
      if (value === null || value === undefined || value === '') {
        this.update(field, 0)
        return
      }

      const numericValue = Number(
        String(value)
          .replace(/[^\d,.-]/g, '')
          .replace(/\./g, '')
          .replace(',', '.')
      )

      this.update(field, Number.isNaN(numericValue) ? 0 : numericValue)
    },

    removeKeyword(index) {
      const words = [...(this.values.words || [])]

      words.splice(index, 1)

      this.update('words', words)
    },

    addKeyword() {
      this.newKeyword = ''
      this.showKeywordModal = true
    },

    confirmAddKeyword() {
      const word = this.newKeyword.trim()

      if (!word) {
        return
      }

      const words = [
        ...(this.values.words || []),
        word
      ]

      this.update('words', words)
      this.newKeyword = ''
    }
  }
}
</script>

<style scoped>
.parameter-group {
  margin-bottom: 24px;
}

.group-title {
  color: #5e5873;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px;
}

.rules-header {
  display: grid;
  grid-template-columns: 1fr 140px;
  align-items: center;
  min-height: 30px;
  margin-left: 16px;
  margin-bottom: 5px;
  padding: 5px 12px;
  background: #f2f1f5;
  color: #5e5873;
  text-align: center;
}

.rules-header span:first-child {
  text-align: center;
}

.rules-header span:last-child {
  text-align: center;
}

.rules-header p {
  margin: 0;
}

.rule-row {
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  min-height: 42px;
  margin-left: 16px;
  padding: 5px 12px;
  color: #5e5873;
}

.rule-row > span:first-child {
  padding-right: 10px;
}

.value-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.money-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
.money-wrapper >>> .form-control {
  width: 180px;
  height: 38px;
  display: inline-block;
}

.value-wrapper >>> .form-control,
.value-wrapper >>> .custom-select {
  height: 38px;
  min-height: 38px;
  width: 100%;
  min-width: 180px;
  padding: 6px 10px;
  border-radius: 4px;
  background: transparent;
  font-size: 13px;
  text-align: center;
  box-shadow: none;
}

.value-wrapper >>> .custom-select {
  padding-right: 20px;
}

.value-wrapper >>> .form-control:focus,
.value-wrapper >>> .custom-select:focus {
  border-color: var(--primary) !important;
  box-shadow: 0 0 0 2px rgba(185, 183, 211, 0.712);
}

.keyword-rule {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.keyword-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px;
  border-color: var(--primary) !important;
  box-shadow: 0 0 0 1px rgba(185, 183, 211, 0.712);
  border-radius: 6px;
}

.keywords {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  flex: 1;
}

.keyword {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 9px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  background: #d1cece;
  color: #000;
  border: 1px solid #ebe9f1;
}

.keyword button {
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-size: 16px;
  color: #000;
  line-height: 1;
}

.keyword-wrapper >>> .btn {
  white-space: nowrap;
  font-size: 11px;
}

.dark-layout .group-title,
.dark-layout .rules-header,
.dark-layout .rule-row,
.dark-layout .value-wrapper span {
  color: #d0d2d6;
}

.dark-layout .rules-header {
  background: #343d55;
}

.beecred-keyword-modal .modal-header,
.beecred-keyword-modal .modal-footer,
.beecred-keyword-modal .modal-body,
.beecred-keyword-modal .form-control {
  background: transparent;
  color: inherit;
}

.beecred-keyword-modal .form-control {
  border: 1px solid rgba(94, 88, 115, 0.25);
}

.beecred-keyword-modal .form-control:focus {
  border-color: var(--primary) !important;
  box-shadow: 0 0 0 2px rgba(185, 183, 211, 0.712);
}

.form-control:focus {
  border-color: var(--primary) !important;
  box-shadow: 0 0 0 2px rgba(185, 183, 211, 0.712);
}
@media (max-width: 768px) {
  .rules-header,
  .rule-row {
    grid-template-columns: 1fr 110px;
  }

  .rule-row {
    margin-left: 0;
  }

  .rules-header {
    margin-left: 0;
  }

  .keyword-wrapper {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>